<template>
  <div class="silde_box">
    <slide-verify
      class="silde_box"
      ref="block"
      :slider-text="text"
      :accuracy="accuracy"
      @again="onAgain"
      @success="onSuccess"
      @fail="onFail"
      @refresh="onRefresh"
      w="260"
      h="120"
    ></slide-verify>
    <!-- <button class="btn" @click="handleClick">在父组件可以点我刷新哦</button> -->
    <!-- <div>{{ msg }}</div> -->
  </div>
</template>
   
  <script>
import { defineComponent, ref } from "vue";
// 局部注册组件，需要单独引用组件样式
// 只提供局部引用的方式，不再采用插件形式，方便按需加载，减少主包大小
import SlideVerify, { SlideVerifyInstance } from "vue3-slide-verify";
import "vue3-slide-verify/dist/style.css";

export default defineComponent({
  components: { SlideVerify },
  data() {
    return {
      msg: null,
      block: null,
      text: "向右滑动->",
      accuracy: 5,
      interval: 20,
    };
  },
  methods: {
    onAgain() {
      this.msg = "检测到非人为操作的哦！ try again";
      // 刷新
      this.block?.refresh();
    },
    onSuccess(times) {
      this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`;
      console.log(this.msg);
      this.$emit("slideSuccess", "success");
    },
    onFail() {
      this.msg = "验证不通过";
    },
    onRefresh() {
      this.msg = "点击了刷新小图标";
    },
    handleClick() {
      this.block?.refresh();
      this.msg = "";
    },
  },
});
</script>
  <style scoped lang="scss">
.silde_box {
  margin: 0 auto;
  width: 260px;
  margin-top: 10px;
  margin-left: 10px;
  #slideVerify{
    width: 260px !important;
    canvas {
      width: 260px !important;
    }
  }
}
</style>